import { AsyncPipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { UserSettingsStateService } from '@services/user-settings.state.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SpinnerBorderRadius } from './global-spinner.modal';
import { FileUrlService } from '@shared/services/file-url.service';
import { BrandingFileRole, FileEntity } from '@shared/models/file.model';

@Component({
  selector: 'od-global-spinner',
  templateUrl: './global-spinner.component.html',
  styleUrls: ['./global-spinner.component.scss'],
  imports: [AsyncPipe],
})
export class GlobalSpinnerComponent {
  public spinnerUrl$: Observable<string>;
  @Input() borderRadius: SpinnerBorderRadius = SpinnerBorderRadius.None;

  constructor(
    userSettingsStateService: UserSettingsStateService,
    private fileUrlService: FileUrlService
  ) {
    this.spinnerUrl$ = userSettingsStateService.theme$.pipe(
      map(theme =>
        this.fileUrlService.getFileUrl({
          entity: FileEntity.BRANDING,
          role: BrandingFileRole.LOADING,
          branding: theme,
          content: true,
        })
      )
    );
  }
}
